<template lang="pug">
  .image-cropper(:class="{'hidden-image-cropp-controls': !originImage}")
    picture-input(
      ref="pictureInput"
      v-show="!originImage"
      :width="boundary.width"
      :height="boundary.height"
      margin="10"
      :customStrings="customStrings"
      :removable="true"
      :prefill="value || resultImage"
      :crop="false"
      @remove="imageRemove"
      @change="imageChange")
    vue-croppie(
      ref="pictureCroppie"
      :enableOrientation="true"
      :viewport="viewport"
      :boundary="boundary"
      :enableResize="resize")
    .croppie-controls(v-if="originImage")
      .buttons.are-small
        button.button(@click="imageCrop") {{ cropButtonText }}
        button.button(v-if="rotate" @click="imageRotate()") {{ 'Rotate' }}
</template>
<script>
import Vue from 'vue'
import VueCroppie from 'vue-croppie'
import PictureInput from 'vue-picture-input'
Vue.use(VueCroppie)

export default {
  name: 'ImageCropper',
  components: {
    PictureInput
  },
  data () {
    return {
      resultImage: '',
      originImage: null
    }
  },
  props: {
    cropButtonText: {
      default: 'Crop image'
    },
    rotateButtonText: {
      default: 'Rotate'
    },
    boundary: {
      default: () => {
        return {
          width: 250,
          height: 250
        }
      }
    },
    viewport: {
      default: () => {
        return {
          width: 200,
          height: 200
        }
      }
    },
    customStrings: {
      default: () => {
        return {
          drag: 'Download image',
          change: 'Change Photo',
          remove: 'Remove Photo',
          select: 'Select a Photo'
        }
      }
    },
    value: {
      default: ''
    },
    resize: {
      default: false
    },
    rotate: {
      default: false
    }
  },
  methods: {
    imageChange (image) {
      this.$emit('change', image)
      if (image) {
        this.originImage = image
        this.$refs.pictureCroppie.bind({
          url: image
        })
      }
    },
    imageRemove () {
      this.resultImage = null
      this.$emit('remove')
    },
    imageCrop () {
      let options = {
        format: 'png',
        circle: false,
        size: 'original'
      }
      this.$refs.pictureCroppie.result(options, (output) => {
        this.resultImage = output
        this.originImage = null
      })
    },
    autoCrop () {
      if (!this.resultImage && this.originImage) {
        this.imageCrop()
      }
    },
    imageRotate () {
      this.$refs.pictureCroppie.rotate(-90)
    }
  },
  watch: {
    resultImage: function (val) {
      this.$emit('input', val)
      this.$emit('cropped', val)
    },
    originImage: function (val) {
      this.$emit('update')
    }
  }
}
</script>

<style lang="scss">
  .picture-inner{
    .picture-inner-text{
      display: flex!important;
      justify-content: center;
      margin-top: 65%;
      position: relative;
      width: 100%;
    }
  }
  .image-cropper{
    position: relative;
    &.hidden-image-cropp-controls{
      margin-bottom: 60px;
      .cr-slider-wrap{
        display: none;
      }
    }
    .buttons {
      display: block;
    }
    .picture-input{
      position: absolute;
      left: 0px;
      top: 0px;
      z-index: 2;
      button{
        font-size: 14px;
        max-width: 49%;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
      }
      .preview-container {
        position: relative;
        &:before {
          content: '';
          position: absolute;
          width: 40%;
          height: 40%;
          left: 50%;
          top: 40%;
          transform: translate(-50%, -50%);
          background-image: url("/webapp/images/icons/upload-image.png");
          background-size: 100%;
          opacity: .4;
        }
      }
    }
  }
  .picture-inner-text{
  }
  @media screen  and (max-width: 360px) {
    .image-cropper{
      .picture-input{
        .preview-container{
          width: 250px!important;
          height: 250px!important;
          max-width: 250px!important;
          max-height: 250px!important;
          canvas{
            width: 250px!important;
            height: 250px!important;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/image-cropper/index.vue